import React from 'react';
import SectionTitle from '../common/SectionTitle';
import { Award, ThumbsUp, Users, Clock, BookOpen, Star } from 'lucide-react';

const WhyChooseUs: React.FC = () => {
  const reasons = [
    {
      icon: <Award size={32} className="text-primary-500" />,
      title: 'Industry Expertise',
      description: 'Our team has years of experience in veterinary education admissions across India.'
    },
    {
      icon: <ThumbsUp size={32} className="text-primary-500" />,
      title: 'Proven Success',
      description: 'High success rate with hundreds of students placed in top veterinary colleges.'
    },
    {
      icon: <Users size={32} className="text-primary-500" />,
      title: 'Personalized Guidance',
      description: 'Tailored counseling based on individual academic profiles and career aspirations.'
    },
    {
      icon: <Clock size={32} className="text-primary-500" />,
      title: 'Timely Support',
      description: 'Prompt assistance throughout the admission process, meeting all deadlines.'
    },
    {
      icon: <BookOpen size={32} className="text-primary-500" />,
      title: 'Comprehensive Resources',
      description: 'Access to study materials, college information, and admission updates.'
    },
    {
      icon: <Star size={32} className="text-primary-500" />,
      title: 'Ethical Practices',
      description: 'Transparent and honest guidance focusing on your best interests and future.'
    }
  ];

  return (
    <section className="section bg-gray-50">
      <div className="container-custom">
        <SectionTitle 
          title="Why Choose Us" 
          subtitle="Our dedicated approach and expertise make us the ideal partner for your veterinary education journey."
        />
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
              <div className="flex items-start">
                <div className="mr-4 mt-1">
                  {reason.icon}
                </div>
                <div>
                  <h3 className="text-lg font-semibold mb-2 text-primary-700">
                    {reason.title}
                  </h3>
                  <p className="text-gray-600">
                    {reason.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;